<template>
  <div class="sidebar-page">
    <b-sidebar
    position="static"
    mobile="fullwidth"
    expand-on-hover
    reduce
    fullheight
    type="is-light"
    open
    class="sidebartmp"
    >
    <div class="p-1">
      <b-menu class="is-custom-mobile">
        <b-menu-list label="ホーム">
          <b-menu-item icon="heart-o" label="最近いいねしたツイート"
                       @click.native="jump_page('/user')" :active="has_current_url('/user')"></b-menu-item>
          <b-menu-item icon="retweet" label="最近RTしたツイート"
                       @click.native="jump_page('/retweet')" :active="has_current_url('/retweet')"></b-menu-item>
          <b-menu-item icon="heart" label="昔いいねしたツイート"
             @click.native="jump_page('/like_log')" :active="has_current_url('/like_log')"></b-menu-item>
          <b-menu-item icon="heart" label="他人がいいねしたツイート"
             @click.native="jump_page('/likes_followed')" :active="has_current_url('/likes_followed')"></b-menu-item>
        </b-menu-list>
        <b-menu-list label="人気">
          <b-menu-item icon="line-chart" label="デイリーランキング"
                       @click.native="jump_page('/ranking/20401230')" :active="has_current_url('/ranking')"></b-menu-item>
          <b-menu-item icon="random" label="ランダムランキング"
                       @click.native="jump_page('/randomranking')" :active="has_current_url('/randomranking')"></b-menu-item>
        </b-menu-list>
        <b-menu-list label="ストック">
          <b-menu-item icon="book" label="自分のストック"
                       @click.native="jump_page('/mystock')" :active="has_current_url('/mystock')"></b-menu-item>
          <b-menu-item icon="book" label="他人のストック"
                       @click.native="jump_page('/followstock')" :active="has_current_url('/followstock')"></b-menu-item>
        </b-menu-list>
        <b-menu-list label="その他">
          <b-menu-item icon="info" label="便利な使い方"
                       @click.native="jump_page('/help')" :active="has_current_url('/help')"></b-menu-item>
          <b-menu-item icon="history" label="更新履歴(ver 0.8)"
                       @click.native="jump_page('/history')" :active="has_current_url('/history')"></b-menu-item>
        </b-menu-list>
      </b-menu>
    </div>
  </b-sidebar>
  </div>
</template>

<script>
export default {
  methods: {
    has_current_url(url) {
      return this.$route.path.includes(url)
    },
    jump_page(url) {
      this.$emit('url-change')
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss">
.p-1 {
  padding: 0.8em;
}
.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  // min-height: 100vh;
  .sidebar-layout {
    display: flex;
    flex-direction: row;
    min-height: 100%;
    // min-height: 100vh;
  }
}
@media screen and (max-width: 1023px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini-mobile {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

.sidebartmp{
  min-height: 100vh;
  height: 100vh;
}
</style>